import { useState } from "react";
import { API } from "@/lib/api";

export const avatarSrc = (userId, v) => (userId && v ? `${API}/auth/avatar/${userId}?v=${v}` : null);

export function Avatar({ userId, v, name, size = 32, className = "", testId }) {
  const [broken, setBroken] = useState(false);
  const src = !broken && avatarSrc(userId, v);
  const initials = (name || "?").split(" ").filter(Boolean).map((w) => w[0]).join("").slice(0, 2).toUpperCase();
  const style = { width: size, height: size, fontSize: Math.max(10, size / 2.6) };
  if (src) return <img src={src} alt={name || ""} data-testid={testId} onError={() => setBroken(true)} style={style} className={`rounded-full object-cover shrink-0 ${className}`} />;
  return <span data-testid={testId} style={style} className={`rounded-full bg-slate-900 text-white font-semibold flex items-center justify-center shrink-0 ${className}`}>{initials}</span>;
}
